import { TableContainer } from "@/components/table-container";
import { RenderbusTag } from "@/components/renderbus-tag";
import { useTranslation } from "react-i18next";
import { BlockTabs } from "@/components";
import { RenderOverview } from "./render-overview";
import { DesktopOverview } from "./desktop-overview";
import { useGlobalStore } from "@/store/GlobalStore";

export function ConsumerOverview() {
  const { t } = useTranslation("center");
  const { userInfo } = useGlobalStore();

  return (
    <TableContainer>
      <RenderbusTag>{t("consumption_warning_overview")}</RenderbusTag>
      <BlockTabs
        items={[
          {
            label: t("tab_render") || "",
            children: <RenderOverview />,
          },
          {
            label: t("tab_desktop") || "",
            hidden: !userInfo?.enableRemoteDesktop,
            children: <DesktopOverview />,
          },
        ]}
      />
    </TableContainer>
  );
}
